import { VipocGroup } from "core/auth/constants"
import { Dispatch } from "react"

export enum ACLReducerActions {
  setACL = 'setACL',
  clearACL = 'clearACL',
}

export type ACLReducerAction = {
  type: ACLReducerActions.setACL
  payload: ACLContextState
} |
{
  type: ACLReducerActions.clearACL
}

export type ACL = Array<Module>

export type Module = VipocGroup

export type ACLContextState = {
  opco: string
  ACL: ACL
}

export type ContextACL = {
  state: ACLContextState
  dispatch: Dispatch<ACLReducerAction>
}